import { OrigoTooltip } from "./OrigoTooltip";
export default OrigoTooltip;
